import { Col, Form, Modal, ModalBody, ModalFooter, Row } from 'react-bootstrap';
import * as formik from 'formik';
import * as yup from 'yup';
import React from 'react';
import Swal from 'sweetalert2';
import ClientService from '../../../repository/clientRepository/ClientRepository';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { strings } from '../../../localization/Localization';

const AddEditClientModal = (props) => {

  const { Formik } = formik;

  const loyaltyStatusOptions = [
    {
      value: 'Standard',
      label: 'Standard'
    },
    {
      value: 'VIP',
      label: 'VIP'
    },
  ];

  const schema = yup.object().shape({
    name: yup.string().required(strings.requiredField),
    surname: yup.string().required(strings.requiredField),
    passportNumber: yup.string().required(strings.requiredField),
    // cardId: yup.string().required(strings.requiredField),
    dateOfBirth: yup.string().required(strings.requiredField),
    phoneNumber: yup.string().required(strings.requiredField),
    email: yup.string().required(strings.requiredField),
    points: yup.string().required(strings.requiredField),
    loyaltyStatus: yup.string().oneOf(['Standard', 'VIP']),
    address: yup.string().required(strings.requiredField),
  });

  const addClientSuccessfulAlert = (message) => {
    Swal.fire({
      icon: 'success',
      title: message,
    });
  };

  const errorAlert = () => {
    Swal.fire({
      title: 'Something went wrong',
      icon: 'error',
      dangerMode: true
    }).then((willDelete) => {
      if (willDelete) {
      }
    });
  };

  const addClient = (name, surname, passportNumber, cardId, dateOfBirth, phoneNumber, email, points, loyaltyStatus, address) => {
    ClientService.addClient(name, surname, passportNumber, cardId, dateOfBirth, phoneNumber, email, points, loyaltyStatus, address)
      .then(() => {
        addClientSuccessfulAlert(strings.successfullyAddedClient);
        props.getClients();
        props.handleClose();
      }).catch(() => {
      errorAlert();
    });
  };

  const updateClient = (id, name, surname, passportNumber, cardId, dateOfBirth, phoneNumber, email, points, loyaltyStatus, address) => {
    ClientService.updateClient(id, name, surname, passportNumber, cardId, dateOfBirth, phoneNumber, email, points, loyaltyStatus, address)
      .then(() => {
        addClientSuccessfulAlert(strings.successfullyUpdatedClient);
        props.getClients();
        props.handleClose();
      }).catch(() => {
      errorAlert();
    });
  };

  function formatDateToDDMMYYYY (dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${day}/${month}/${year}`;
  }

  const onFormSubmit = (values) => {
    const name = values.name !== '' ? values.name : null;
    const surname = values.surname !== '' ? values.surname : null;
    const passportNumber = values.passportNumber !== '' ? values.passportNumber : null;
    const cardId = values.cardId !== '' ? values.cardId : null;
    const dateOfBirth = values.dateOfBirth !== '' ? values.dateOfBirth : null;
    const phoneNumber = values.phoneNumber !== '' ? values.phoneNumber : null;
    const email = values.email !== '' ? values.email : null;
    const points = values.points !== '' ? values.points : null;
    const loyaltyStatus = values.loyaltyStatus || 'Standard';
    const address = values.address !== '' ? values.address : null;

    const stringDateOfBirth = formatDateToDDMMYYYY(dateOfBirth);

    if (props.selectedClientForEdit?.id) {
      updateClient(props.selectedClientForEdit?.id, name, surname, passportNumber, cardId, stringDateOfBirth, phoneNumber, email, points, loyaltyStatus, address);
    } else {
      addClient(name, surname, passportNumber, cardId, stringDateOfBirth, phoneNumber, email, points, loyaltyStatus, address);
    }
  };

  const getInitialValue = (fieldName, editValue) => {
    if (props.selectedClientForEdit?.id) {
      return editValue || '';
    }

    switch (fieldName) {
      case 'passportNumber':
      case 'phoneNumber':
      case 'email':
      case 'address':
      case 'cardId':
        return '/';
      case 'dateOfBirth':
        return new Date('2000-01-01');
      default:
        return '';
    }
  };

  const fields = [
    {
      name: 'name',
      label: strings.name,
      type: 'text',
      placeholder: 'Marta'
    },
    {
      name: 'surname',
      label: strings.surname,
      type: 'text',
      placeholder: 'Martevska'
    },
    {
      name: 'passportNumber',
      label: strings.passportNumber,
      type: 'text',
      placeholder: 'A123456'
    },
    {
      name: 'cardId',
      label: strings.identityCard,
      type: 'text',
      placeholder: 'A123456'
    },
    {
      name: 'dateOfBirth',
      label: strings.dateOfBirth,
      type: 'date',
      placeholder: '01/01/2000'
    },
    {
      name: 'phoneNumber',
      label: strings.phoneNumber,
      type: 'text',
      placeholder: '+38970123456'
    },
    {
      name: 'email',
      label: strings.email,
      type: 'email',
      placeholder: 'marta@gmail.com'
    },
    {
      name: 'points',
      label: strings.points,
      type: 'number',
      placeholder: '100'
    },
    {
      name: 'loyaltyStatus',
      label: strings.loyaltyStatus,
      type: 'text',
      placeholder: 'Obichen'
    },
    {
      name: 'address',
      label: strings.address,
      type: 'text',
      placeholder: 'Goce Delchev br. 2'
    },
  ];

  const renderFields = (fields, values, handleChange, errors, touched) =>
    fields.map(({
      name,
      label,
      type,
      placeholder
    }) => {
      if (name === 'dateOfBirth') {
        return (
          <Form.Group as={Col} md='6' controlId={`validationFormik_${name}`} key={name}>
            <Form.Label>{label}</Form.Label>
            <ReactDatePicker
              selected={values[name] ? new Date(values[name]) : null}
              onChange={(date) => handleChange({
                target: {
                  name,
                  value: date
                }
              })}
              dateFormat='dd/MM/yyyy'
              className={`form-control ${touched[name] && errors[name] ? 'is-invalid' : ''}`}
              wrapperClassName='w-100'
              placeholderText={!props.selectedClientForEdit?.id ? placeholder : ''}
            />
            <Form.Control.Feedback type='invalid'>{errors[name]}</Form.Control.Feedback>
          </Form.Group>
        );
      }
      if (name === 'loyaltyStatus') {
        return (
          <Form.Group as={Col} md='6' controlId={`validationFormik_${name}`} key={name}>
            <Form.Label>{label}</Form.Label>
            <Form.Select
              name={name}
              value={values[name]}
              onChange={handleChange}
              isValid={touched[name] && !errors[name]}
              isInvalid={touched[name] && !!errors[name]}
            >
              {loyaltyStatusOptions.map((option) => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type='invalid'>{errors[name]}</Form.Control.Feedback>
          </Form.Group>
        );
      }
      return (
        <Form.Group as={Col} md='6' controlId={`validationFormik_${name}`} key={name}>
          <Form.Label>{label}</Form.Label>
          <Form.Control
            type={type}
            name={name}
            value={values[name]}
            onChange={handleChange}
            isValid={touched[name] && !errors[name]}
            isInvalid={touched[name] && !!errors[name]}
            placeholder={!props.selectedClientForEdit?.id ? placeholder : ''}
          />
          <Form.Control.Feedback type='invalid'>{errors[name]}</Form.Control.Feedback>
        </Form.Group>
      );
    });

  const convertToDisplayDate = (date) => {
    const [day, month, year] = date.split('/');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  };

  return (
    <Modal show={props.showModal} onHide={props.handleClose} size='lg' centered>
      <Modal.Header closeButton>
        <Modal.Title>{props.selectedClientForEdit?.id ? strings.updateClient : strings.addClient}</Modal.Title>
      </Modal.Header>
      <Formik
        validationSchema={schema}
        onSubmit={onFormSubmit}
        initialValues={{
          name: props.selectedClientForEdit?.name ? props.selectedClientForEdit?.name : '',
          surname: props.selectedClientForEdit?.surname ? props.selectedClientForEdit?.surname : '',
          passportNumber: getInitialValue('passportNumber', props.selectedClientForEdit?.passportNumber),
          cardId: getInitialValue('cardId', props.selectedClientForEdit?.cardId),
          dateOfBirth: props.selectedClientForEdit?.dateOfBirth ? convertToDisplayDate(props.selectedClientForEdit?.dateOfBirth) : getInitialValue('dateOfBirth'),
          phoneNumber: getInitialValue('phoneNumber', props.selectedClientForEdit?.phoneNumber),
          email: getInitialValue('email', props.selectedClientForEdit?.email),
          points: props.selectedClientForEdit?.points ? props.selectedClientForEdit?.points : '',
          loyaltyStatus: props.selectedClientForEdit?.loyaltyStatus ? props.selectedClientForEdit?.loyaltyStatus : '',
          address: getInitialValue('address', props.selectedClientForEdit?.address),
        }}
      >
        {({
          handleSubmit,
          handleChange,
          values,
          touched,
          errors
        }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <ModalBody>
              <Row className='mb-3'>
                {renderFields(fields, values, handleChange, errors, touched)}
              </Row>
            </ModalBody>
            <ModalFooter>
              <button type='submit' className='btn btn-primary'>{strings.submit}</button>
            </ModalFooter>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default AddEditClientModal;